import React from 'react';
import { Container } from 'react-bootstrap';
import { Link, useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import classNames from 'classnames';
import { v1 as uuid } from 'uuid';
import { useWindowDimensions } from '../../utilities/general';
import * as styles from './homeSectionWorks.module.scss';

const HomeSectionWorks = ({
  works,
  worksTitle,
  viewMoreWork
}) => {
  const { width } = useWindowDimensions();
  const { defaultBannerImg } = useStaticQuery(graphql`
    {
      defaultBannerImg: file(relativePath: { eq: "default-banner.png" }) {
        childImageSharp {
          fluid(maxWidth: 1080) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <section className={styles.section}>
      <Container>
        <h2 className={styles.title}>
          <span className={styles.titleLine} />
          <span className={styles.titleText}>{worksTitle}</span>
          {viewMoreWork && (
            <Link className={styles.titleLink} to="/work">View more work</Link>
          )}
        </h2>

        {works.map(({ work }) => (
          <Link
            key={uuid()}
            to={`/work/${work.uid}`}
            className={classNames(styles.work, styles[work.document.data.main_menu_color.toLowerCase()])}
          >
            {/* Mobile and thumbnail image exists */}
            {width < 576 && work.document.data.banner_homepage_image.thumbnails
              && (
                <img
                  className={styles.workImage}
                  src={work.document.data.banner_homepage_image.thumbnails.Mobile.url}
                  alt={work.document.data.banner_homepage_image.thumbnails.Mobile.alt}
                />
              )}

            {/* Mobile and thumbnail image does not exist */}
            {width < 576 && !work.document.data.banner_homepage_image.thumbnails
              && (
                <Img className={styles.workImage} fluid={defaultBannerImg.childImageSharp.fluid} />
              )}

            {/* Desktop and image exists */}
            {width > 576 && work.document.data.banner_homepage_image.fluid
              && (
                <Img
                  className={styles.workImage}
                  fluid={work.document.data.banner_homepage_image.fluid}
                  alt={work.document.data.banner_homepage_image.alt}
                />
              )}

            {/* Desktop and image does not exist */}
            {width > 576 && !work.document.data.banner_homepage_image.fluid
              && (
                <Img className={styles.workImage} fluid={defaultBannerImg.childImageSharp.fluid} />
              )}

            <div className={styles.workContent}>
              <h3 className={styles.workTitle}>{work.document.data.client_name.text}</h3>
              <p className={styles.workText}>{work.document.data.case_study_name.text}</p>
              <p className={styles.workLink}>Read case study</p>
            </div>
          </Link>
        ))}
      </Container>
    </section>
  );
};

export default HomeSectionWorks;
